<template>
  <svg
    width="26"
    height="27"
    viewBox="0 0 26 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="changeChapter"
  >
  <path
    d="M13 0C5.824 0 0 6.048 0 13.5C0 20.952 5.824 27 13 27C20.176 27 26 20.952 26 13.5C26 6.048 20.176 0 13 0ZM9.75 19.575V7.425L18.85 13.5L9.75 19.575Z"
    :fill="fill"
  />
  </svg>

</template>

<script>

export default {
  props: ['current'],
  data() {
    return {
      fill: '#E0E1E2',
    }
  },
  methods: {
    changeChapter() {
      this.$emit('changeChapter');
    },
    isCurrent() {
      if(this.current) {
        this.fill = '#FAFF00';
      } else {
        this.fill = '#E0E1E2';
      }
    }
  },
  created() {
    this.isCurrent();

  },
  watch: {
    current() {
      this.isCurrent();
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/fanClub/notes/svg/ChapterPlay.vue